import * as muiLocales from '@material-ui/core/locale';
import { strict } from 'assert';
import locales from './locales';

const values = JSON.parse(process.env.REACT_APP_LOCALES_MATERIAL_UI);

if (process.env.NODE_ENV === 'development') {
  strict.equal(
    values.length,
    locales.length,
    'Each locale has Material UI locale'
  );
}

const getMaterialUI = (locale) => muiLocales[values[locales.indexOf(locale)]];

export default getMaterialUI;
